import {
    SET_ASSET_ITEM_STATUS_HEADER_DETAIL
} from "./AssetItemStatusHeaderDetailsType"

const initialState = {
    assetItemStatusHeaderDetail: []
}


const reducer = (state = initialState, action: any) => {
    switch (action.type) {
        case SET_ASSET_ITEM_STATUS_HEADER_DETAIL:
            return {
                ...state,
                assetItemStatusHeaderDetail: action.assetItemStatusHeaderDetail
            };
        default:
            return state;
    }
};

export default reducer;